import RolesPage from './RolesPage';
import { connect } from 'react-redux';
import {
  fetchRolesForAdmin,
  createRole,
  editRole
} from '../../../actions/role_actions';
import { bindActionCreators } from 'redux';
import { completeRequest } from '../../../actions/request_state';
import { fetchPermissionsNames } from '../../../actions/permission_actions';

function mapStateToProps(state) {
  return {
    roles: state.role.roles,
    requestRolesSend: state.requestState.requestRolesAdminSend,
    requestSaveRoleSend: state.requestState.requestSaveRoleSend,
    meta: state.role.meta,
    canCreateRolesAdmin: state.authentication.currentUser.canCreateRolesAdmin,
    canEditRolesAdmin: state.authentication.currentUser.canEditRolesAdmin,
    requestErrorsOnSaveRole: state.requestState.requestErrorsOnSaveRole
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRoles: bindActionCreators(fetchRolesForAdmin, dispatch),
    createRole: bindActionCreators(createRole, dispatch),
    editRole: bindActionCreators(editRole, dispatch),
    completeRequest: bindActionCreators(completeRequest, dispatch),
    fetchPermissionsNames: bindActionCreators(fetchPermissionsNames, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RolesPage);
